'use client'

import { createContext, useContext } from 'react'

import type { Testimonial } from './content/testimonials'
import type { SiteSettings } from './site-settings'

type SiteSettingsContextValue = SiteSettings & {
  testimonial: Testimonial
  googleReviewsUrl: string
}

const SiteSettingsContext = createContext<SiteSettingsContextValue | null>(null)

export function SiteSettingsProvider({
  value,
  children,
}: {
  value: SiteSettingsContextValue
  children: React.ReactNode
}) {
  return <SiteSettingsContext.Provider value={value}>{children}</SiteSettingsContext.Provider>
}

/**
 * Read site context (settings + featured testimonial + reviews URL) inside a
 * client component. Must be inside a SiteSettingsProvider (mounted in
 * src/app/(site)/layout.tsx). For server components, import the dedicated
 * getters (getSiteSettings, getFeaturedTestimonial, getNavigation).
 */
export function useSiteSettings(): SiteSettingsContextValue {
  const ctx = useContext(SiteSettingsContext)
  if (!ctx) {
    throw new Error('useSiteSettings must be used inside SiteSettingsProvider.')
  }
  return ctx
}
